import React from 'react'
import { useSelector } from 'react-redux'
import config from '../../config/config';

const ChatBotWeb = ({ isWhiteLable }) => {
    const domain = (window.location.hostname === 'localhost') ? 'zyratalk.clavis.digital' : window.location.hostname;
    // console.log(domain);
    const { app, chatDemo } = useSelector(state => state);

    let hColorMultiArr = [];
    let hColorMulti = '';
    if (app.contextData.buttonHeaderColor.length > 1) {
        app.contextData.buttonHeaderColor.map((x, y) => {
            hColorMultiArr.push(x);
        });
        hColorMulti = hColorMultiArr.join();
    }


    let bColorMultiArr = [];
    let bColorMulti = '';
    if (app.contextData.buttonColor.length > 1) {
        app.contextData.buttonColor.map((x, y) => {
            bColorMultiArr.push(x);
        });
        bColorMulti = bColorMultiArr.join();

    }

    return (
        <div>

            <div className="yr-preview-box">
                <div className='yr-preview'>
                    {/* <div className="yr-preview-menu">
                        <span className="closebtn" onClick={() => { }}>×</span>
                        <a target="_blank" href=''>Privacy Policy</a>
                    </div> */}
                    <header
                        style={app.contextData.buttonHeaderColor.length == 1 ? { background: app.contextData.buttonHeaderColor[0] } : { backgroundImage: 'linear-gradient(45deg,' + hColorMulti + ')' }}
                    >
                        <div className="yr-logo brand-left">
                            <span className='small-img-logo zy--img'>
                                {isWhiteLable ?
                                    <img src={
                                        app.contextData.companyLogo == ""
                                            // ? `${process.env.PUBLIC_URL}/images/logos/logo.png`
                                            ? `${process.env.PUBLIC_URL}/images/whitelablechaticon.jpg`

                                            : (app.contextData.companyLogo.includes('assets') ? `${config.baseurl}/${app.contextData.companyLogo}` : `${app.contextData.companyLogo}`)
                                    } alt="" style={{ maxWidth: 40, maxHeight: 35 }} />
                                    :
                                    <img src={
                                        app.contextData.companyLogo == ""
                                            // ? `${process.env.PUBLIC_URL}/images/logos/logo.png`
                                            ? `${process.env.PUBLIC_URL}/images/logos/logo.png`

                                            : (app.contextData.companyLogo.includes('assets') ? `${config.baseurl}/${app.contextData.companyLogo}` : `${app.contextData.companyLogo}`)
                                    } alt="" style={{ maxWidth: 40, maxHeight: 35 }} />
                                }
                            </span>
                            {isWhiteLable ?
                                <div className="brand-name">{app.contextData.company_information.companyName ? app.contextData.company_information.companyName : 'Your Company Name'}</div> :
                                <div className="brand-name">{app.contextData.company_information.companyName ? app.contextData.company_information.companyName : 'ZyraTalk'}</div>}
                        </div>
                        <div className="yr-button">
                            <span className="yr-close">
                                <i className="fas fa-undo fa-sm"></i>
                            </span>
                            <span className="yr-nav" onClick={() => { }}>
                                <i className='fa fa-ellipsis-v '></i>
                            </span>
                            <span className="yr-close"><i className="fa fa-times" /></span>
                        </div>
                        <svg viewBox="0 0 500 150" preserveAspectRatio="none" style={{ height: '40%', width: '100%' }}><path d="M0.00,49.98 C149.99,150.00 347.35,-22.20 500.00,49.98 L500.00,150.00 L0.00,150.00 Z" style={{ stroke: 'none', fill: '#fff' }} /></svg>
                    </header>
                    <div className="yr-body">
                        <div className="yr-body-top">

                            <span class="yr-chatlogo-mini zy--img zy--p0">
                                {isWhiteLable ? <img src={
                                    app.contextData.companyLogo == ""
                                        ? `${process.env.PUBLIC_URL}/images/whitelablechaticon.jpg`
                                        : (app.contextData.companyLogo.includes('assets') ? `${config.baseurl}/${app.contextData.companyLogo}` : `${app.contextData.companyLogo}`)
                                } alt="" />
                                    : <img src={
                                        app.contextData.companyLogo == ""
                                            ? `${process.env.PUBLIC_URL}/images/logos/logo.png`
                                            : (app.contextData.companyLogo.includes('assets') ? `${config.baseurl}/${app.contextData.companyLogo}` : `${app.contextData.companyLogo}`)
                                    } alt="" />}

                            </span>
                            <span className="welcome-text">Welcome to The {app.contextData.company_information.companyName} demo. Click one of the buttons to get started!</span>
                        </div>

                        <div className="yr-body-bottom">
                            <span className="btn yrbtn"
                                style={app.contextData.buttonColor.length == 1 ? { background: app.contextData.buttonColor[0], color: app.contextData.buttonTextColor } : { backgroundImage: 'linear-gradient(45deg,' + bColorMulti + ')', color: app.contextData.buttonTextColor }}
                            >I want to chat <span className="yr-chat" /></span>
                            <span className="btn  yrbtn" style={app.contextData.buttonColor.length == 1 ? { background: app.contextData.buttonColor[0], color: app.contextData.buttonTextColor } : { backgroundImage: 'linear-gradient(45deg,' + bColorMulti + ')', color: app.contextData.buttonTextColor }}
                            >Call now <span className="yr-call" /></span>
                            <span className="btn  yrbtn" style={app.contextData.buttonColor.length == 1 ? { background: app.contextData.buttonColor[0], color: app.contextData.buttonTextColor } : { backgroundImage: 'linear-gradient(45deg,' + bColorMulti + ')', color: app.contextData.buttonTextColor }}
                            >Leave a review <span className="yr-star" /></span>
                        </div>
                        <div className="yr-footer">
                            {/* <p dangerouslySetInnerHTML={{ __html: app.contextData.footerText }} className="text-center mb-0"></p> */}
                            <p className="text-center mb-0" style={{ fontSize: 11 }}>We're <span class='footer-logo'></span> by <a style={{ color: '#0188ce' }} href={`https://${domain}`} target='_blank'>{domain}</a></p>
                        </div>
                    </div>
                </div>
                <div className="yr-chat-logo-row">
                    {/* <div className="yr-chat-logo" 
                                style={{ backgroundImage: 'linear-gradient(45deg,'+ app.contextData.primaryColor +','+ app.contextData.secondaryColor +')' }}>
                                </div> */}
                    <div style={{ position: 'relative' }}>
                        <label
                            className="image-checkbox"
                            style={{ backgroundImage: 'linear-gradient(45deg,' + app.contextData.primaryColor + ',' + app.contextData.secondaryColor + ')' }}
                        // style={{ backgroundImage: 'linear-gradient(45deg,'+ app.contextData.primaryColor +','+ app.contextData.secondaryColor +')' }}
                        >
                            <img className="img-responsive" id='preViewIcon' src={`${process.env.PUBLIC_URL}/images/logos/${app.contextData.selectedTheme}`} alt="" style={{ maxWidth: 52, maxHeight: 52 }} />
                        </label>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ChatBotWeb